var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9034 1.25271C17.2939 1.64323 17.2939 2.2764 16.9034 2.66692L9.461 10.1093C9.44766 10.1227 9.43404 10.1355 9.42016 10.148L9.15887 10.4093C8.76834 10.7998 8.13518 10.7998 7.74465 10.4093L0.292689 2.95734C-0.0978109 2.56681 -0.0978109 1.93365 0.292689 1.54312L1.25249 0.583439C1.64299 0.192839 2.27619 0.192839 2.66669 0.58344L8.45286 6.36959L14.5295 0.292941C14.92 -0.0975591 15.5531 -0.0975591 15.9437 0.292941L16.9034 1.25271Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.75b5b0bee7f819d0706c8327f1e03eec.svg";
export { ForwardRef as ReactComponent };